// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tags[data-v-33cbfdfc] {\n  min-height: 50px;\n}\n.cursor-drag[data-v-33cbfdfc] {\n  cursor: grab;\n}", ""]);
// Exports
module.exports = exports;
